<template>
    <div class="gallery-modal" v-show="isOpen" style="display: block;">
        <div class="gallery-modal-inner">

        <span class="gallery-modal-close" @click="closeModal">
          <svg class="close"><use xlink:href="#close"></use></svg>
        </span>

         <div class="gallery-modal-content" v-if="review">
        <div class="content">
            <div class="slide-content-">
                <a :href="`/user/${review.user.username}`" class="avatar">
                    <img :src="review.user.profile_thumbnail" data-rjs="2" />
                </a>
                <p v-text="gallery[currentIndex].caption"></p>
            </div>
        </div>
        <div class="content-count">
            <div>
                <span id="current-image" v-text="(currentIndex + 1)"></span>
                of
                <span id="total-images" v-text="gallery.length"></span>
            </div>
        </div>
    </div>

        <div class="gallery-modal-image">
            <div class="gallery-images" v-if="gallery.length">
                <VueSlickCarousel
                    v-bind="slickConfig"
                    ref="carousel"
                    @init="initCarousel($event)">

                    <div class="img-wrap" v-for="(image, i) in gallery" :key="i">
                        <img :src="image.modal" :alt="image.caption" v-rjs="2">
                    </div>

                </VueSlickCarousel>
            </div>

            <span class="gallery-modal-prev" @click="showPrev()">
                <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
            </span>

            <span class="gallery-modal-next" @click="showNext()">
                <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
            </span>

            </div>

        </div>
    </div>
</template>

<script>

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {

    components: {
        VueSlickCarousel
    },

    data() {
        return {
            slickConfig: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: true,
                fade: true,
                dots: true,
                initialSlide: this.index,
            },
            isOpen: false,
            gallery: [],
            review: null,
            currentIndex: 0,
        }
    },

    created() {
        eventBus.$on('display-media-image', data => {
            this.review = data.review
            this.gallery = data.review.gallery
            this.currentIndex = data.index
            this.isOpen = true
        })
    },

    methods: {

            initCarousel() {
                this.$nextTick(() => {
                    this.$refs.carousel.goTo(this.currentIndex)
                })
            },

            showNext() {
                if(this.currentIndex == (this.gallery.length - 1)){
                    this.currentIndex = 0
                    this.$refs.carousel.goTo(this.currentIndex)
                    return
                }
                this.currentIndex = this.currentIndex + 1
                this.$refs.carousel.next()
            },

            showPrev() {
                if(this.currentIndex == 0) {
                    this.currentIndex = (this.gallery.length -1)
                    this.$refs.carousel.goTo(this.currentIndex)
                    return
                }
                this.currentIndex = this.currentIndex - 1
                this.$refs.carousel.prev()
            },

            closeModal() {
                this.isOpen = false
            },
    },

    // watch: {
    //     isOpen(newVal) {
    //         if (newVal) {
    //             this.displayIndex = this.index + 1
    //         }
    //     },
    // },
    //
    // computed: {
    //     activeCaption() {
    //         if (!this.images.length) return null
    //
    //         return this.images[this.displayIndex - 1].custom_properties.caption
    //     },
    //
    //     imageGallery(){
    //         return this.gallery ? this.gallery : this.images
    //     }
    // },


}
</script>

<style lang="scss" scoped>
.slick-slider {
    height: 100%;
}
</style>
